function toggleNoticeCard(cardEl, event) {
    // Detiene la propagación para que solo se afecte esta tarjeta
    if (event) event.stopPropagation();
    cardEl.classList.toggle('open');
}

//# sourceMappingURL=public.87101237.js.map
